(function (Drupal, $) {
  Drupal.behaviors.ajax = {
    attach: (context, settings) => {
      if (!Drupal.Ajax) {
        return;
      }

      Drupal.Ajax.prototype.success = function (response, status) {
        // Remove the progress element.
        if (this.progress.element) {
          $(this.progress.element).remove();
        }
        if (this.progress.object) {
          this.progress.object.stopMonitoring();
        }
        $(this.element).prop('disabled', false);

        // Save element's ancestors tree so if the element is removed from the dom
        // we can try to refocus one of its parents. Using addBack reverse the
        // result array, meaning that index 0 is the highest parent in the hierarchy
        // in this situation it is usually a <form> element.
        const elementParents = $(this.element)
          .parents('[data-drupal-selector]')
          .addBack()
          .toArray();

        // Track if any command is altering the focus so we can avoid changing the
        // focus set by the Ajax command.
        let focusChanged = false;
        Object.keys(response || {}).forEach((i) => {
          if (response[i].command && this.commands[response[i].command]) {
            this.commands[response[i].command](this, response[i], status);
            if (
              response[i].command === 'invoke' &&
              response[i].method === 'focus'
            ) {
              focusChanged = true;
            }
          }
        });

        // If the focus hasn't be changed by the ajax commands, try to refocus the
        // triggering element or one of its parents if that element does not exist
        // anymore.
        if (
          !focusChanged &&
          this.element &&
          !$(this.element).data('disable-refocus')
        ) {
          let target = null;

          for (let n = elementParents.length - 1; !target && n >= 0; n--) {
            target = document.querySelector(
              `[data-drupal-selector="${elementParents[n].getAttribute(
                'data-drupal-selector',
              )}"]`,
            );
          }

          if (target) {
            // Scroll into select 'Choix dossier ou RDV'.
            const rdvCenterField = document.querySelector('select[name="vali_quest"]');
            if (rdvCenterField && target === rdvCenterField) {
              window.setTimeout(() => {
                const rdvCenterFieldWrap = document.querySelector('.form__item-vali-quest');
                rdvCenterFieldWrap.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                  inline: 'nearest',
                });
              }, 100);
            }

            const registerStep2 = document.querySelector('.imc-form__actions');
            if (target === registerStep2) {
              window.setTimeout(() => {
                const registerStep3 = document.querySelector('.preregister__step-3');
                registerStep3.focus();
              }, 100);
            }

            // $(target).trigger('focus');
          }
        }

        // Reattach behaviors, if they were detached in beforeSerialize(). The
        // attachBehaviors() called on the new content from processing the response
        // commands is not sufficient, because behaviors from the entire form need
        // to be reattached.
        if (this.$form && document.body.contains(this.$form.get(0))) {
          const settings = this.settings || drupalSettings;
          Drupal.attachBehaviors(this.$form.get(0), settings);
        }

        // Remove any response-specific settings so they don't get used on the next
        // call by mistake.
        this.settings = null;
      };
    }
  };
}(Drupal, jQuery));
